import { ChatSpotV1Client } from 'ai-components-ui-library/clients/ChatSpotApi';
import httpClient from 'hub-http/clients/apiClient';
export const fetchAllPromptTemplates = locale => {
  // E.G. https://tools.hubteamqa.com/api/request/bc7539696cd34c47847397d7de0ea4b1
  return httpClient.get('chatspot/v1/api/prompt-templates/prioritized', {
    query: {
      locale: encodeURIComponent(locale)
    }
  });
};
export const fetchRoutePriorities = pathname => {
  // E.G. https://tools.hubteamqa.com/api/request/ba971eca85ee4422b101f2152ccc7dcf
  return httpClient.post('chatspot/v1/api/template-priorities', {
    data: {
      route: pathname
    }
  });
};
export const fetchAllFavoritePrompts = () => {
  return ChatSpotV1Client.get('favorites');
};
export const saveFavoritePrompt = prompt => {
  return ChatSpotV1Client.post('favorites', {
    data: {
      prompt
    }
  });
};
export const removeFavoritePrompt = id => {
  return ChatSpotV1Client.delete(`favorites/${id}`);
};